module.exports = __webpack_public_path__ + "img/safieScrn2.0f5c8cc3.png";